const mutationTypes = {
  SET_CURRENT_TIME_VIDEO_PLAYING: 'SET_CURRENT_TIME_VIDEO_PLAYING',
  SET_TEXT_TRACKS: 'SET_TEXT_TRACKS',
  SET_CURRENT_ACTIVE_TEXT_TRACK: 'SET_CURRENT_ACTIVE_TEXT_TRACK',
  SET_CURRENT_ACITVE_CUBES: 'SET_CURRENT_ACITVE_CUBES',
  SET_CURRENT_ACTIVE_CUBE_TEXT: 'SET_CURRENT_ACTIVE_CUBE_TEXT',
  RESET_TRANSCRIPT_VIDEO_PLAYING: 'RESET_TRANSCRIPT_VIDEO_PLAYING',
}

export const state = () => ({
  currentTimeVideoPlaying: -1,
  textTracks: [],
  currentActiveTrackText: null,
  currentActiveCues: [],
  currentActiveCueText: null,
})

export const mutations = {
  [mutationTypes.SET_CURRENT_TIME_VIDEO_PLAYING](state, currentTimeVideoPlaying) {
    state.currentTimeVideoPlaying = currentTimeVideoPlaying
  },
  [mutationTypes.SET_TEXT_TRACKS](state, textTracks) {
    state.textTracks = textTracks.slice()
  },
  [mutationTypes.SET_CURRENT_ACTIVE_TEXT_TRACK](state, currentActiveTrackText) {
    state.currentActiveTrackText = currentActiveTrackText
  },
  [mutationTypes.SET_CURRENT_ACITVE_CUBES](state, currentActiveCues) {
    state.currentActiveCues = currentActiveCues
  },
  [mutationTypes.SET_CURRENT_ACTIVE_CUBE_TEXT](state, currentActiveCueText) {
    state.currentActiveCueText = currentActiveCueText
  },
  [mutationTypes.RESET_TRANSCRIPT_VIDEO_PLAYING](state) {
    state.currentTimeVideoPlaying = null
    state.textTracks = []
    state.currentActiveTrackText = null
    state.currentActiveCues = []
    state.currentActiveCueText = null
  },
}

export const getters = {
  currentVideoPlaying: (state) => state,
  // List transcript - Default is eng transcript
  currentActiveCuesPlaying: (state) => {
    const { currentActiveTrackText, textTracks } = state
    const currentActiveTrackTextId =
      currentActiveTrackText && currentActiveTrackText.id ? currentActiveTrackText.id : 'track-english'

    if (textTracks.length > 0) {
      const textTrackPlaying = textTracks.find((track) => track.id === currentActiveTrackTextId)
      return textTrackPlaying && textTrackPlaying.cues ? textTrackPlaying.cues : []
    }
    return []
  },
}
